import {CommonModule} from '@angular/common';
import {Component, input} from '@angular/core';
import {brand} from '../../../../../settings';

@Component({
  selector: 'app-partners-logos',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './partners-logos.component.html',
  styleUrl: './partners-logos.component.scss'
})
export class PartnersLogosComponent {
    public partnerLogos = input<{ src: string; alt: string; class: string }[]>();
    public readonly brand = brand;
}
